import * as ng from 'angular';

const templateUrl = require('./private-placeholder.directive.html');

ng.module('e360')
   .directive('privatePlaceholder', privatePlaceholderDirective);

privatePlaceholderDirective.$inject = ['session'];
export function privatePlaceholderDirective(session):ng.IDirective {
   return {
      restrict: 'E',
      transclude: true,
      scope: { file: '=' },
      templateUrl: templateUrl,
      link: privatePlaceholdLink
   };

   function privatePlaceholdLink(scope, element: JQuery, attrs: ng.IAttributes) {
      scope.showPlaceholder = !session.isAdmin() && scope.file.private;
   }
}
